import { render, staticRenderFns } from "./limit.vue?vue&type=template&id=5d420983&scoped=true&"
import script from "./limit.vue?vue&type=script&lang=js&"
export * from "./limit.vue?vue&type=script&lang=js&"
import style0 from "./limit.vue?vue&type=style&index=0&id=5d420983&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d420983",
  null
  
)

export default component.exports